import apiClient from '@/utils/request'
import {
  ISpotsListsPayload,
  ISpotsListAttributes,
  ISpotsListData,
  ISpotListBulkUpdateAttributes,
  ISpotsListsResponse,
  ISpotsListResponse,
  ISpotsListImportPayload,
  ISpotsListImportResponse
} from '@/apps/traforama/interfaces/spotsLists'

import { nestedQueryFormatter } from '@/utils/query'

export const fetchItems = async (
  payload: ISpotsListsPayload
): Promise<ISpotsListsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<ISpotsListsResponse>('/spots_lists', {
    params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<ISpotsListResponse> => {
  const response = await apiClient.get<ISpotsListResponse>(`/spots_lists/${id}`)
  return response.data
}

export const createItem = async (
  payload: ISpotsListAttributes
): Promise<ISpotsListResponse> => {
  const response = await apiClient.post<ISpotsListResponse>(
    '/spots_lists',
    payload
  )
  return response.data
}

export const updateItem = async (
  item: ISpotsListData
): Promise<ISpotsListResponse> => {
  const payload = { spot_ids: item.spot_ids }
  const response = await apiClient.put<ISpotsListResponse>(
    `/spots_lists/${item.id}`,
    payload
  )
  return response.data
}

export const destroyItem = async (id: string): Promise<ISpotsListResponse> => {
  const response = await apiClient.delete<ISpotsListResponse>(
    `/spots_lists/${id}`
  )
  return response.data
}

export const importItems = async (
  payload: ISpotsListImportPayload
): Promise<ISpotsListImportResponse> => {
  if (!payload.id || payload.isNew) {
    delete payload.id
  }
  const response = await apiClient.post<ISpotsListImportResponse>(
    '/spots_lists/import',
    payload
  )
  return response.data
}

export const bulkUpdate = async (
  item: ISpotListBulkUpdateAttributes
): Promise<ISpotsListResponse> => {
  const payload = { ...item }
  const response = await apiClient.put<ISpotsListResponse>(
    '/spots_lists/bulk_update',
    payload
  )
  return response.data
}
